import React, { useEffect } from "react";
import {
    FiMic,
    FiMicOff,
    FiVideo,
    FiVideoOff,
    FiMonitor,
    FiMessageSquare,
    FiPhoneOff,
} from "react-icons/fi";
import "./VideoCallScreen.css";

const VideoCallScreenDesign = ({
    visible,
    localVideoRef,
    remoteVideoRef,
    localName = "You",
    remoteName = "Remote User",
    onEndCall,
    isMicEnabled = true,
    isCameraEnabled = true,
    isScreenSharing = false,
    onToggleMic,
    onToggleCamera,
    onToggleScreenShare,
}) => {
    useEffect(() => {
        if (!visible) return;

        const localVideo = localVideoRef?.current;
        const remoteVideo = remoteVideoRef?.current;

        if (localVideo?.srcObject) {
            localVideo.play().catch(() => { });
        }

        if (remoteVideo?.srcObject) {
            remoteVideo.play().catch(() => { });
        }
    }, [visible, localVideoRef, remoteVideoRef]);

    if (!visible) return null;

    return (
        <div className="video-call-page">
            <button className="end-call-btn" onClick={onEndCall} type="button">
                <FiPhoneOff />
                <span>End call</span>
            </button>

            <div className="video-grid">
                <div className="video-card">
                    <video
                        ref={localVideoRef}
                        className="video-feed"
                        autoPlay
                        playsInline
                        muted
                    />
                    <div className="video-overlay-name">{localName}</div>
                </div>

                <div className="video-card">
                    <video
                        ref={remoteVideoRef}
                        className="video-feed"
                        autoPlay
                        playsInline
                    />
                    <div className="video-overlay-name">{remoteName}</div>
                </div>
            </div>

            <div className="bottom-controls">
                <button
                    className={`control-btn ${isMicEnabled ? "active" : ""}`}
                    type="button"
                    onClick={onToggleMic}
                >
                    {isMicEnabled ? <FiMic /> : <FiMicOff />}
                    <span>{isMicEnabled ? "Mic on" : "Mic off"}</span>
                </button>

                <button
                    className={`control-btn ${isCameraEnabled ? "active" : ""}`}
                    type="button"
                    onClick={onToggleCamera}
                >
                    {isCameraEnabled ? <FiVideo /> : <FiVideoOff />}
                    <span>{isCameraEnabled ? "Cam on" : "Cam off"}</span>
                </button>

                <button
                    className={`control-btn ${isScreenSharing ? "active" : ""}`}
                    type="button"
                    onClick={onToggleScreenShare}
                >
                    <FiMonitor />
                    <span>{isScreenSharing ? "Stop Share" : "Share Screen"}</span>
                </button>

                <button className="control-btn" type="button">
                    <FiMessageSquare />
                    <span>Chat</span>
                </button>
            </div>
        </div>
    );
};

export default VideoCallScreenDesign;